import { render, staticRenderFns } from "./TableListConfig.vue?vue&type=template&id=58e628b8&scoped=true"
import script from "./TableListConfig.vue?vue&type=script&lang=js"
export * from "./TableListConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e628b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58e628b8')) {
      api.createRecord('58e628b8', component.options)
    } else {
      api.reload('58e628b8', component.options)
    }
    module.hot.accept("./TableListConfig.vue?vue&type=template&id=58e628b8&scoped=true", function () {
      api.rerender('58e628b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/config/TableListConfig.vue"
export default component.exports